export default __webpack_public_path__ + "static/media/Climbing.d6579f2d.webp";